import { SignOut } from '@phosphor-icons/react';

export default function Header({ user, onLogout }) {
  return (
    <header className="bg-white border-b border-[#E4E4E7] px-8 py-4 flex items-center justify-between" data-testid="header">
      <div>
        <h2 className="text-xl font-bold text-[#09090B]" data-testid="header-greeting">
          Welcome back, {user?.name?.split(' ')[0]}
        </h2>
        <p className="text-sm text-[#52525B] capitalize">Role: {user?.role}</p>
      </div>

      <button
        onClick={onLogout}
        className="flex items-center gap-2 px-4 py-2 btn-secondary"
        data-testid="logout-button"
      >
        <SignOut size={18} />
        <span>Logout</span>
      </button>
    </header>
  );
}
